"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERC721ReceiverMock__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    indexed: true,
    internalType: "bool",
    name: "isMinting",
    type: "bool"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "TokenReceived",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "enum ERC721ReceiverMock.Error",
    name: "error",
    type: "uint8"
  }],
  name: "setErrorType",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";

const isSuperArgs = xs => xs.length > 1;

class ERC721ReceiverMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.ERC721ReceiverMock__factory = ERC721ReceiverMock__factory;

_defineProperty(ERC721ReceiverMock__factory, "bytecode", _bytecode);

_defineProperty(ERC721ReceiverMock__factory, "abi", _abi);